import React from 'react'
import Typography from '@material-ui/core/Typography';
import moment from 'moment'
const styles = {
    headlineContainer: {
        borderBottom: '2px solid #3f51b5',
        marginBottom: '1.0em'
    },
    headline: {
        display: 'inline-block'

    },
    counterContainer: {
       
        display: 'inline-block',
        width: '100%',

    },
    counterLable: {
        marginRight: '8px'
    },
}

const PageHeadline = (props)=> {

    const {headline, subtext } = props
    return (
        <div>
            <div style={styles.headlineContainer}>
                <Typography style={styles.headline} color='primary' variant="headline">
                    {headline} 
                </Typography>
                <span style={{color: '#3f51b5', float: 'right', fontSize: '1.0', marginTop:'6px'}}>{moment().format('L')}</span>
            </div>
            <div>
                {typeof(subtext)!=='undefined'
                    ? <Typography variant='subheading'>
                            {subtext}
                        </Typography>
                    : null
                }
            </div>          
        </div>
    )
}


export default PageHeadline


// WEBPACK FOOTER //
// ./src/Container/Headlines/PageHeadline.js